import React from 'react';
import BusyModeCard from '../BusyModeCard';
import ItemBreakDown from '../Tables/ItemBreakDown';
import OosTableCard from '../Tables/OOSTable/OosTableCard';

const Operations = () => (
  <div className="flex flex-col gap-y-4">
    <OosTableCard />
    <ItemBreakDown />
    <BusyModeCard />
  </div>
);

export default Operations;
